import { render, staticRenderFns } from "./addInfoItem.vue?vue&type=template&id=6abb3c84&scoped=true"
import script from "./addInfoItem.vue?vue&type=script&lang=js"
export * from "./addInfoItem.vue?vue&type=script&lang=js"
import style0 from "./addInfoItem.vue?vue&type=style&index=0&id=6abb3c84&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abb3c84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6abb3c84')) {
      api.createRecord('6abb3c84', component.options)
    } else {
      api.reload('6abb3c84', component.options)
    }
    module.hot.accept("./addInfoItem.vue?vue&type=template&id=6abb3c84&scoped=true", function () {
      api.rerender('6abb3c84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/hwk/addInfoItem.vue"
export default component.exports